// extracted by mini-css-extract-plugin
export var wordContainer = "_rj-0";